export enum VatRatesFlowEnum {
  OUTGOING = 'OUTGOING',
  INCOMING = 'INCOMING',
}
